import Modal from "react-modal";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { GoCalendar } from "react-icons/go";
import { BsPlusCircleFill } from "react-icons/bs";

import "./add-company.css";
import { IconContext } from "react-icons";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { FaLock } from "react-icons/fa";
import { FaCalendarAlt } from "react-icons/fa";

interface DateListModalProps {
  open: boolean;
  handleClose: () => void;
  updateData: (date: string) => void;
  data?: string[];
}

const customStyles = {
  content: {
    top: "45%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "10px",
  },
};

const DateListModal = (props: DateListModalProps) => {
  const { handleClose, open, updateData, data } = props;

  const handleUpdateData = (date: string) => {
    console.log("Selected date:", date?.split("_")[1]);
    updateData(date?.split("_")[1] );
    handleClose();
  };
  return (
    <Modal
      isOpen={open}
      onRequestClose={handleClose}
      style={customStyles}
      contentLabel="Add Company"
      ref={(e) => e}
      ariaHideApp={false}
    >
      <div className="add-company-modal">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "20px 24px 16px",
            borderBottom: "2px solid #e9ecef",
            marginBottom: "16px",
            width: "100%",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "1.5rem",
              fontWeight: "700",
              color: "#2c3e50",
              letterSpacing: "-0.5px",
            }}
          >
            Select Payslip
          </h2>
          <button
            className="close-icon"
            onClick={handleClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: "8px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
              ":hover": {
                backgroundColor: "#fee2e2",
              },
            }}
            // onMouseEnter={(e) => {
            //   e.currentTarget.style.backgroundColor = "#fee2e2";
            //   e.currentTarget.style.transform = "scale(1.1)";
            // }}
            // onMouseLeave={(e) => {
            //   e.currentTarget.style.backgroundColor = "transparent";
            //   e.currentTarget.style.transform = "scale(1)";
            // }}
          >
            <IconContext.Provider value={{ color: "#dc2626", size: "24px" }}>
              <AiOutlineCloseCircle />
            </IconContext.Provider>
          </button>
        </div>

        {/* <div className="line" /> */}
        {/* <div
          style={{
            display: "flex",
            width: "100%",
            padding: "10px",
            marginLeft: "30px",
            alignItems: "center",
          }}
        >
          <div
            style={{
              border: "none",
              backgroundColor: "transparent",
              display: "flex",
              alignItems: "center",
            }}
          >
            <IconContext.Provider value={{ color: "#000", size: "20px" }}>
              <BsPlusCircleFill />
            </IconContext.Provider>
            <NavLink className="modal-link" to="">
              Manually Add Payslip
            </NavLink>
          </div>
        </div> */}
        <Wrap className="body">
          {data?.map((item) => {
            return (
              <PayslipDateContainer
                className="payslip-date"
                onClick={() => handleUpdateData(item)}
                key={item}
              >
                <IconContext.Provider value={{ color: "059bbf", size: "20px", style: { marginRight: "4px" } }}>
                  <FaCalendarAlt />
                </IconContext.Provider>
                <DateText className="date-text">{item.split("_")[1]}</DateText>
                <LockContainer>
                  {item.split("_")[0] !== "0" && (
                    <IconContext.Provider value={{ size: "16px" }}>
                      <FaLock />
                    </IconContext.Provider>
                  )}
                </LockContainer>
              </PayslipDateContainer>
            );
          })}
        </Wrap>
      </div>
    </Modal>
  );
};

export default DateListModal;
const Wrap = styled.div`
  overflow-y: scroll;
  max-width: 50vw;
  max-height: 60vh;
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

const PayslipDateContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  /* margin: 1px 0; */
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  /* cursor: pointer; */
  transition: all 0.2s ease;
  /* gap: 12px; */

  /* &:hover {
    background-color: #e9ecef;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  } */
`;

const DateText = styled.p`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #059bbf;
`;

const LockContainer = styled.div`
  margin-left: auto;
  width: 40%;
  display: flex;
  justify-content: center;
`;
